import { FormattedMessage, injectIntl } from "react-intl";
import React, { Component } from "react";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

class QuestionSync extends Component {
  constructor(props) {
    super(props);
    this._resetDialog = this._resetDialog.bind(this);
    this.sync = this.sync.bind(this);
  }

  render() {
    const { show, template } = this.props;

    return (
      <Modal className="surveySettingsContainer" show={show} enforceFocus autoFocus>
        <div>
          <Modal.Body>
            <h4>
              <FormattedMessage id="template.activation.title" />
            </h4>
            <FormattedMessage className="label-default" id="template.question.sync.dialog.message" />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this._resetDialog}>
              <FormattedMessage id="app.common.Close" />
            </Button>
            <Button onClick={() => this.sync(template)}>
              <FormattedMessage id="app.common.activate" />
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  }

  sync(template) {
    this.props.actions.syncQuestions(template);
  }

  _resetDialog() {
    this.props.actions.resetDialog(this.props.externalActions.close);
  }
}

QuestionSync.propTypes = {
  show: PropTypes.bool,
  template: PropTypes.object,
  resetDialog: PropTypes.func,
  syncQuestions: PropTypes.func
};

export default injectIntl(QuestionSync);
